import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-opacity": ".5",
  d: "m15 8 .94.342a1 1 0 0 0 0-.684zM1 8l-.94-.342a1 1 0 0 0 0 .684zm8.686 4.233a1 1 0 1 0 .628 1.9zm-4 1.9a1 1 0 1 0 .628-1.9zM1 8l.94.342v.001q-.001.001 0 0l.014-.038.06-.147a9.907 9.907 0 0 1 1.384-2.274C4.419 4.637 5.912 3.5 8.001 3.5v-2c-2.91 0-4.917 1.612-6.149 3.117A12 12 0 0 0 .177 7.37a7 7 0 0 0-.115.284l-.001.003zm7-4.5c2.09 0 3.582 1.138 4.601 2.383a10 10 0 0 1 1.384 2.275l.076.186v-.001L15 8l.94-.343-.002-.003-.002-.006-.03-.076-.083-.202a11.904 11.904 0 0 0-1.674-2.753C12.918 3.112 10.911 1.5 8 1.5zM15 8l-.94-.344h.001l-.001.004-.01.023-.042.106a10.143 10.143 0 0 1-.998 1.789c-.744 1.058-1.837 2.164-3.324 2.655l.628 1.9c2.054-.68 3.46-2.165 4.332-3.406a12 12 0 0 0 1.207-2.167l.079-.196.005-.014.002-.005v-.002zm-8.686 4.233c-1.487-.491-2.58-1.597-3.324-2.655a10 10 0 0 1-.998-1.789l-.052-.13-.001-.003v.001L1 8l-.94.342v.001l.001.002.024.063.062.152c.053.128.132.307.237.523.21.431.53 1.017.97 1.644.871 1.241 2.278 2.726 4.332 3.405z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "2",
  fill: "#fff",
  "fill-opacity": ".5"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }